import { ISavedSearchColumnModel } from '../models/saved-search-filter.model';
import { SavedSearchNS } from './../models/saved-search.models';

export function getSavedSearchTableColumns(selectedColums: SavedSearchNS.SavedSearchColumnSetting[]): any[] {
    let columns: ISavedSearchColumnModel[] = [];
    if (selectedColums) {
        let i = 1;
        selectedColums?.map(f => {
            f?.fields?.filter(f => f.isSelected == true)?.map(x => {
                //nested field
                if (x?.nestedFields?.length > 0) {
                    x.nestedFields?.filter(n => n.isSelected == true)?.map(nestObj => {
                        columns.push(
                            {
                                id: i + 1,
                                field: prepareColumnNameFromCriteria(nestObj.criteriaUsed),
                                header: `${x.name}: ${nestObj.labelName}`,
                                fieldNameDB: nestObj.fieldName,
                                dataType: nestObj.fieldDataType == 'DateTime' ? 'date' : (nestObj.fieldDataType == 'Number' || nestObj.fieldDataType == 'Decimal') && nestObj.fieldName != 'Qty' ? 'number' : nestObj.fieldDataType == 'Money' ? 'currency' : 'string',
                                fieldDataType: nestObj.fieldDataType,
                                formControlType: nestObj?.formControlType,
                                isShow: nestObj.isSelected,
                                isCustom: x.isCustom
                            });
                        i = i + 1;
                    })
                }
                else {
                    columns.push(
                        {
                            id: i + 1,
                            field: prepareColumnNameFromCriteria(x.criteriaUsed),
                            header: x.labelName,
                            fieldNameDB: x.fieldName,
                            dataType: x.fieldDataType == 'DateTime' ? 'date' : (x.fieldDataType == 'Number' || x.fieldDataType == 'Decimal') ? 'number' : x.fieldDataType == 'Money' ? 'currency' : 'string',
                            fieldDataType: x.fieldDataType as any,
                            formControlType: x?.formControlType,
                            isShow: x.isSelected,
                            isCustom: x.isCustom
                        });
                    i = i + 1;
                }
            });
        });
        // console.log(this.selectedSearch);
    }
    return columns;
}

export function prepareColumnNameFromCriteria(str?: string){
    return str?.length > 0 ? str[0].toLocaleLowerCase()+str.slice(1) : str;
}
